import 'dev';
import { axiosHttpHandler } from './config/interop/default/axiosHttpHandler';
import { checkPermissionsHandler } from './config/interop/default/checkPermissionsHandler';
import { loginWithTaskHandler } from './config/interop/default/loginWithTaskHandler';
import { navigationHandler } from './config/interop/default/navigationHandler';
import { openWindowDownloadDocument } from './config/interop/default/openWindowDownloadDocument';
import { init } from './init';

init({
  render: (app, render) => render(app, document.querySelector('#root')),
  embeddingInterop: {
    sendHttpRequest: axiosHttpHandler,
    downloadDocument: openWindowDownloadDocument,
    handleNavigation: navigationHandler,
    checkPermissions: checkPermissionsHandler,
    loginWithTask: loginWithTaskHandler,
    subscribeOnTriggerPermissionCheck: () => undefined
  }
});
